module.exports = __webpack_public_path__ + "img/IMG_7189_L_BlackMatted.6ef6b2d8.jpg";